import {fadeIn, fadeOut, fadeOutFadeIn} from "../../core/js/Animate.ts";
import {
    $,
    $$,
    createElement,
    getParentElementByClassName,
    getParentElementByTagName, hide,
    html_chargement_en_cours
} from "../../core/js/Dom.ts";
import {$get, $post, $postForm} from "../../core/js/Ajax.ts";
import {initTooltips} from "../../core/js/Tooltip.ts";
import {initSelects} from "../../core/js/Select.ts";
import {initDropzone} from "../../core/js/Dropzone.ts";
import Dropzone, {DropzoneFile, DropzoneMockFile} from "dropzone";
import {createErrorNotification, createSuccessNotification} from "../../portail/js/Notifications.ts";
import {generateModale, hideModal, initHistoryModal} from "../../core/js/Modal.ts";
import {initNotesForm} from "../../core/js/Notes.ts";
import {date_picker_init} from "../../core/js/DatePicker.ts";
import {createDataTables} from "../../core/js/DataTables.ts";
import {updateMenuInfos} from "../../core/js/Onglets.ts";
import {refreshAlerts} from "../../portail/js/DossierAlerts.ts";


function handleSubmitPieceJointeInstructeur(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const form = getParentElementByTagName(event.target, 'form') as HTMLFormElement
    if (form) {
        const data = new FormData(form)
        const url = form.action
        $postForm(url, data).then((response) => {
            if (response.body === "ok") {
                createSuccessNotification({
                    message: 'Demande de pièce jointe envoyée.'
                })
                reloadOnglet()
            } else {
                createErrorNotification({
                    message: response.body
                })
            }
        }).catch((erreur) => {
            createErrorNotification({
                message: erreur.message
            })
        })
    }
}
function validerPieceJointe(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const element = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    if (element) {
        let id = element.dataset.pj
        const url = new URL(element.href)
        url.searchParams.append('pk', String(id))
        url.searchParams.append('valider', String(1))
        $post(url.toString()).then((response) => {
            if (response.body === 'ok') {
                createSuccessNotification({
                    message: 'Pièce validée.'
                })
                reloadOnglet()
            } else {
                createErrorNotification({
                    message: response.body
                })
            }
        })
    }
}

function sendPjMotifForm(url: URL, message: string){
    $post(url.toString()).then((response) => {
        if (response.body === 'ok') {
            createSuccessNotification({
                message: message
            })
            hideModal("modal_motif_pj")
            reloadOnglet()
        } else {
            createErrorNotification({
                message: response.body
            })
        }
    })
}

function devalidatePieceJointe(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const element = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    if (element) {
        let id = element.dataset.pj
        let libelle_pj =  element.dataset.test
        const textarea = createElement('div', ['fr-input-group', 'fr-p-2w'])
        textarea.innerHTML = `
            <label class="fr-label" for="motif_octroi_acces_lecture">
                Raison :
            </label>
            <textarea
                    class="fr-input"
                    id="motif_demande_modification"
                    name="motif_demande_modification"
                    rows="6"
                    cols="55"
            ></textarea>
        `
        const btn = createElement('button', ['fr-btn'])
        btn.id = "enregistrer_demande_modif"
        btn.innerText = "Enregistrer"
        generateModale("modal_motif_pj", {
            title: "Veuillez détailler la raison de la demande modification de la pièce jointe " + libelle_pj,
            content: textarea,
            title_in_header: true,
            actions: [
                btn
            ],
        })
        const url = new URL(element.href)
        const modale_motif_demande_modification = $<HTMLInputElement>('#motif_demande_modification')
        url.searchParams.append('pk', String(id))
        url.searchParams.append('valider', String(0))
        btn.addEventListener('click', function (){
            // dans le cas où la modale demandant la raison des modifications des PJ est bien définie
            if (modale_motif_demande_modification) {
                // on récupère le message de justification
                url.searchParams.append('motif_demande_modification', modale_motif_demande_modification.value)
            }
            sendPjMotifForm(url, 'Validation de la pièce annulée.', )
        })
    }
}

function rendreObligatoirePieceJointe(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const element = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    const url = new URL(element.href)
    let libelle_pj =  element.dataset.test
    if (url) {
        fetch(url.toString())
            .then(response => {
                if (!response.ok) {
                    throw new Error("Erreur lors de la récupération des données");
                }
                return response.text();
            })
            .then(data => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data;
                const contentNode = tempDiv.firstElementChild as HTMLElement;
                generateModale("modal_motif_pj", {
                    title: `Merci de préciser la raison pour laquelle la pièce jointe "${libelle_pj}" est rendue obligatoire.`,
                    content: contentNode,
                    title_in_header: true,
                })
            })
    }
}

function revalidatePieceJointe(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const element = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    if (element) {
        let id = element.dataset.pj
        let libelle_pj =  element.dataset.test
        const textarea = createElement('div', ['fr-input-group', 'fr-p-2w'])
        textarea.innerHTML = `
            <label class="fr-label" for="motif_octroi_acces_lecture">
                Raison :
            </label>
            <textarea
                    class="fr-input"
                    id="motif_demande_modification"
                    name="motif_demande_modification"
                    rows="6"
                    cols="55"
            ></textarea>
        `
        const btn = createElement('button', ['fr-btn'])
        btn.id = "annuler_enregistrer_demande_modif"
        btn.innerText = "Enregistrer"
        generateModale("modal_motif_pj", {
            title: "Veuillez détailler la raison de l\'annulation de la demande modification de la pièce jointe " + libelle_pj,
            content: textarea,
            title_in_header: true,
            actions: [
                btn
            ],
        })
        const url = new URL(element.href)
        const modale_motif_demande_annulation_modification = $<HTMLInputElement>('#motif_demande_modification')
        url.searchParams.append('pk', String(id))
        url.searchParams.append('revalider', String(1))
        btn.addEventListener('click', function (){
            // dans le cas où la modale demandant la raison de l'annulation des modifications des PJ est bien définie
            if (modale_motif_demande_annulation_modification) {
                // on récupère le message de justification
                url.searchParams.append('motif_demande_modification', modale_motif_demande_annulation_modification.value)
            }
            sendPjMotifForm(url, 'Demande de modification annulé.', )
        })
    }
}

function reloadOnglet() {
    const urlRefresh = $<HTMLElement>('[aria-controls="pieces-jointes"]')?.dataset?.url
    if(urlRefresh) {
        $get(urlRefresh).then((data) => {
            updateOngletContent(data.body)
        })
    }
}

export function initPieceJointeOnglet() {

    const onglet = $<HTMLElement>('#pieces-jointes')
    initTooltips(onglet)
    initSelects(onglet)
    initHistoryModal(onglet)
    date_picker_init();
    const addBtn = $("#btnsubmit_supp")
    const addFile = $<HTMLFormElement>('#dropzone_form_supp')
    $('#btnedit_supp')?.addEventListener('click', afficherAjouterPieceJointe)

    $$('#formobj_supp :not(div).form-control-pj-supp').forEach(element => {
        element.addEventListener('change', () => {
            let tout_remplie = true;
            $$<HTMLInputElement>('#formobj_supp :not(div).form-control-pj-supp').forEach((input) => {
                if (!input.value || input.value.length === 0) {
                    tout_remplie = false
                }
            })
            if (tout_remplie) {
                addBtn?.removeAttribute('disabled')
            } else {
                addBtn?.setAttribute('disabled', 'true')
            }
        })
    })
    addFile?.addEventListener('dropzone-uploaded', refreshOngletContent)

    $$('.ajout_pj').forEach(el => el.addEventListener('click', toggleDropZone))
    $$('.edit_pj').forEach(el => el.addEventListener('click', handleEditPieceJointe))

    // listener instructeur
    $$<HTMLElement>('.validation_pj').forEach(el => el.addEventListener('click', validerPieceJointe))
    $$<HTMLElement>('.devalidation_pj').forEach(el => el.addEventListener('click', devalidatePieceJointe))
    $$<HTMLElement>('.revalidation_pj').forEach(el => el.addEventListener('click', revalidatePieceJointe))
    $$<HTMLElement>('.rendre_obligatoire_pj').forEach(el => el.addEventListener('click', rendreObligatoirePieceJointe))
    $('#formobj_supp')?.addEventListener('submit', handleSubmitPieceJointeInstructeur)

    if(window.Openscop.isInstructeur) {
        $$('.tab_line').forEach(el => {
            if (el.hasAttribute('data-pj')) {
                el.addEventListener('mouseenter', toggleNoteIcon)
                el.addEventListener('mouseleave', toggleNoteIcon)
            }
        })
    }
    $$('.aff_note').forEach(el => el.addEventListener('click', showModalNotes))
    $$<HTMLElement>('.dropzone-pj-organisateur').forEach(element => {
        initDropzone(element)
        element.addEventListener('dropzone-uploaded', refreshOngletContent)
    })

    createDataTables("#pj_table", {
        "paging": false,
        "info": false,
    }).then(() => {
        hide($('.dataTables_filter', onglet!))
        hide($('.dt-search', onglet!))
    })
}

export function refreshOngletContent(event: DOMEvent<HTMLElement>) {
    updateOngletContent((event as CustomEvent)?.detail?.body)
    requestAnimationFrame(updateMenuInfos)
    requestAnimationFrame(refreshAlerts)
}

function updateOngletContent(content: string) {
    $('#pieces-jointes')!.innerHTML = content;
    initPieceJointeOnglet()
}

function handleEditPieceJointe(event: DOMEvent<HTMLElement>) {
    event.preventDefault();
    const target = getParentElementByClassName(event.target, 'edit_pj')
    if (target) {
        const id = target.id.split("_")[1]
        const myDropzone = Dropzone.forElement(`#dropzone_form_${id}`);
        const thumbnail = target.getAttribute('data-thumbnail')
        const name = target.getAttribute('data-pj-name')
        const size = target.getAttribute('data-pj-size')
        if (name && size && thumbnail) {
            const mockFile: DropzoneMockFile = {name, size: Number(size)};
            myDropzone?.options?.addedfile?.call(myDropzone, (mockFile as DropzoneFile))
            myDropzone?.options?.thumbnail?.call(myDropzone, (mockFile as DropzoneFile), thumbnail);
        }
    }
}

function toggleDropZone(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const source = getParentElementByClassName(event.target, 'ajout_pj')
    if (source) {
        const id = source.id.substring(8)
        fadeOutFadeIn($(`#detail_${id}`), $(`#champ_${id}`))
    }
}

function afficherAjouterPieceJointe() {
    fadeOutFadeIn($('#btnedit_supp'), $('#champ_supp'))
}

function toggleNoteIcon(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, 'tr')
    if(target) {
        const notes = $('.aff_note', target)
        if(event.type === "mouseleave") {
            fadeOut(notes)
        } else {
            fadeIn(notes)
        }
    }
}

function showModalNotes(event: DOMEvent<HTMLElement>) {
    // aff_note
    const target = getParentElementByTagName(event.target, 'button')
    const pj_pk = target?.dataset.pj
    const url = target?.dataset.url

    if(url) {
        const modalId = `modal-note-pj-${pj_pk}`
        generateModale(modalId, {
            content: html_chargement_en_cours(),
            title: 'Notes',
            title_in_header: true,
        })
        $get(url).then((response) => {
            const content = $(`#${modalId}-modal__content`)
            if (content) {
                content.innerHTML = response.body
            }
            initNotesForm(content, `#dropzone_form_note_${pj_pk}`)
        })
    }
}